module.exports = __webpack_public_path__ + "img/online_payment_and_balance_monitoring.a5757294.svg";